import { ButtonBase } from "@mui/material";
import { tokens } from "../../theme";

/**
 * Chip de la barra de filtros del Design Kit (§11): píldora 12px/600. Activo =
 * azul sólido con texto blanco; inactivo = blanco con borde gris.
 */
export default function FiltroChip({ label, activo, onClick }: { label: string; activo: boolean; onClick: () => void }) {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        fontSize: 12,
        fontWeight: 600,
        padding: "6px 13px",
        borderRadius: "500px",
        bgcolor: activo ? tokens.azul[600] : tokens.etiqueta.contorno.bg,
        color: activo ? tokens.neutro.blanco : tokens.etiqueta.contorno.fg,
        border: activo ? "1px solid transparent" : `1px solid ${tokens.etiqueta.contorno.borde}`,
      }}
    >
      {label}
    </ButtonBase>
  );
}
